import {
    GET_LIST,
} from "../../api/user/user";
import querystring from "query-string";

const state = {
    list: [],
    detail: {},
    qr: "",
    pointing_users: [],
    status_user: {
        total_active: 0,
        total_away: 0,
        total_wfo: 0,
        total_wfh: 0,
    },
};
const mutations = {
    SET_LIST: (state, payload) => {
        state.list = payload;
    },
};
const actions = {
    GET_LIST: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_LIST(params);
        const data = resp.data.data;
        commit("SET_LIST", data);
    },
};
const getters = {
    list: (state) => state.list,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
